

AFRAME.registerComponent('spatial-audio', {
    schema: {
        max: {
            type: 'number',
            default: 2
        },
        min: {
            type: 'number',
            default: 1
        },
        target: {
            type: 'selector'
        }
    },
    init: function () {
        this.cameraPosition = new THREE.Vector3();
        this.position = new THREE.Vector3();
    },
    tick: function () {
        const getSquaredDistanceToCamera = (thisElement) => {
            thisElement.object3D.getWorldPosition(this.position);
            document.querySelector('[camera]').object3D.getWorldPosition(this.cameraPosition);
            const dx = this.position.x - this.cameraPosition.x;
            const dz = this.position.z - this.cameraPosition.z;
            return dx * dx + dz * dz;
        }
        const squaredDistance = getSquaredDistanceToCamera(this.el);
        let volume;
        if (squaredDistance > this.data.max * this.data.max) {
            volume = 0;
        } else if (squaredDistance < this.data.min * this.data.min) {
            volume = 1;
        } else  {
            const length = this.data.max - this.data.min;
            const value = Math.sqrt(squaredDistance) - this.data.min;
            volume = 1 - value / length;
        }
        this.data.target.volume = volume;
        if (isMobile && volume === 0 && this.data.target.currentTime > 0 && !this.data.target.paused && !this.data.target.ended) {
            this.data.target.pause();
        }
    },
});